import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { IncrementSelector, TextField } from '@elementary/common-ui/components';
import useDebounce from '@elementary/common-ui/hooks/useDebounce';

const TextFieldStyled = styled(TextField)`
  width: 35px;
  min-width: 35px;
  border: none;
  padding: 3px;
  text-align: center;
`;

type Props = {
  value?: string;
  onChange: (val: string) => void;
  maxValue: number;
};

const HopSelector = ({ value, onChange, maxValue }: Props) => {
  const [internalVal, setInternalVal] = useState(value || '');
  const debouncedVal = useDebounce(internalVal);

  useEffect(() => {
    setInternalVal(value || '');
  }, [value]);

  useEffect(() => {
    if (debouncedVal !== '' && debouncedVal !== value) {
      onChange(debouncedVal);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedVal]);

  const handleChange = (val: string) => {
    if (val === '' || Number(val) <= maxValue) {
      setInternalVal(val);
    }
  };

  const handlePlus = () => {
    const numVal = Number(internalVal);
    handleChange(((numVal || 0) + 1).toString());
  };

  const handleMinus = () => {
    const numVal = Number(internalVal);
    handleChange(((numVal || 1) - 1).toString());
  };

  const handleKeyDown = (e: any) => {
    if (e.key === 'ArrowUp') {
      handlePlus();
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    if (e.key === 'ArrowDown') {
      handleMinus();
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <IncrementSelector
      onPlus={handlePlus}
      onMinus={handleMinus}
      disablePlus={Number(internalVal) >= maxValue}
      disableMinus={Number(internalVal) === 0}
    >
      <TextFieldStyled
        variant="standard"
        inputProps={{ style: { textAlign: 'center' } }}
        value={internalVal}
        onChange={(e: any) => handleChange(e.target.value)}
        onKeyDown={handleKeyDown}
        onFocus={(e) => e.target.select()}
        numeric
      />
    </IncrementSelector>
  );
};

export default HopSelector;
